import { render, staticRenderFns } from "./InputICO.vue?vue&type=template&id=fa4601aa"
import script from "./InputICO.vue?vue&type=script&lang=js"
export * from "./InputICO.vue?vue&type=script&lang=js"
import style0 from "./InputICO.vue?vue&type=style&index=0&id=fa4601aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports